import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { FORM_BUILDER_FIELD_TYPE, MaterialIcon } from "@loanbossinc/component-library";

import { shouldShowField } from "./section-logic";

const filterDropDown = (selectedItems, deliverables, index) => {
  // fix to allow dropdown checkboxes to be deselected
  const map = new Map();
  selectedItems.forEach(item => map.set(item, map.has(item) ? map.get(item) + 1 : 1));
  const filteredSelectedItems = selectedItems.filter(item => map.get(item) === 1);

  return filteredSelectedItems.map(selectedItem => ({ id: selectedItem, deliverableId: deliverables[index].id, configItemId: selectedItem }));
};

const FinancialReportingEditRows = (reportType, index, label, deliverableType, onRemove) => ({
  title: {
    label,
    isTitle: true,
    buttonLabel: "Remove",
    onTitleButtonClick: () => {
      onRemove(index);
    },
    titleButtonStyle: { color: "#C40A0A", float: "right", border: "1px solid #C40A0A" }
  },
  reportingEntity: {
    isVisible: data => shouldShowField(deliverableType, "reportingEntity"),
    label: "Reporting Entity",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "frequency",
        name: `deliverables[${index}].reportingEntityId`,
        variant: "filled",
        parentId: "reportingEntities",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (value, formik) => {
          formik.setFieldValue(`deliverables[${index}].deliverablesConfigItems`, []);
        }
      }
    ]
  },
  reportingType: {
    isVisible: data => shouldShowField(deliverableType, "reportingType"),
    label: "Reporting Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "frequency",
        name: `deliverables[${index}].reportingTypeId`,
        variant: "filled",
        parentId: "reportingTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id

      }
    ]
  },
  frequency: {
    label: "Frequency",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "frequency",
        name: `deliverables[${index}].reportingFrequencyId`,
        variant: "filled",
        parentId: "frequencies",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  },

  reportingPeriodStart: {
    label: (<div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ width: "175px" }}>Reporting Period Start </span>
      <Tooltip title="Reporting Period refers to the calendar or fiscal period that your reporting is done over. Ex. Reporting due 45 days after the end of the calendar year would be input as December of the year your reporting is due." placement="right">
        <MaterialIcon iconName="info_outline" className="material-icons" />
      </Tooltip>
    </div>),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `deliverables[${index}].reportingStartDate`,
        variant: "filled",
        hideDay: true
      }
    ]
  },
  deliveryPeriod: {
    label: "Delivery Period",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `deliverables[${index}].deliveryPeriodDays`,
        variant: "filled",
        onClientChange: (value, formik) => {
          if (!value || Number.isNaN(Number(value)) || Number(value) < 0) {
            value = 0;
            formik.setFieldValue(`deliverables[${index}].deliveryPeriodDays`, value);
          } else if (value && !Number.isNaN(Number(value)) && Number(value) > 365) {
            value = 365;
            formik.setFieldValue(`deliverables[${index}].deliveryPeriodDays`, value);
          }

          return value;
        },
        style: { width: "176px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "frequency",
        name: `deliverables[${index}].deliveryPeriodProximityId`,
        variant: "filled",
        parentId: "deliveryPeriodProximities",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        style: { marginLeft: "10px" }
      }
    ]
  },
  reportingPeriodEnd: {
    label: "Reporting Period End",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `deliverables[${index}].reportingEndDate`,
        hideDay: true,
        variant: "filled",
        isDisabled: data => data?.deliverables[index]?.sameAsMaturity
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.CHECKBOX,
        label: "Same as Maturity",
        name: `deliverables[${index}].sameAsMaturity`,
        variant: "filled",
        hideLabel: true

      }
    ]
  },
  listOfDocumentsToBeDelivered_guarantor: {
    isVisible: data => data.deliverables[index].deliverableType === "cashManagement" && data.deliverables[index].reportingEntityId === "1fd8dfd1-593d-443b-b8dc-24e7ddcf3e64",
    label: "List of documents to be delivered",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: `deliverables[${index}].deliverablesConfigItems`,
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "guarantorDocsRows",
        onChange: (selectedItems, formik) => {
          const { deliverables } = formik.values;
          let deliverablesConfigItems = [];

          if (selectedItems !== null && selectedItems.length > 0) {
            deliverablesConfigItems = filterDropDown(selectedItems, deliverables, index);
          }
          deliverables[index].deliverablesConfigItems = deliverablesConfigItems;
          formik.setValues({ ...formik.values, deliverables });
        }
      }
    ]
  },
  listOfDocumentsToBeDelivered_borrower: {
    isVisible: data => data.deliverables[index].deliverableType === "cashManagement" && data.deliverables[index].reportingEntityId === "54812867-2a39-4cf4-ac61-b332e5890a10",
    label: "List of documents to be delivered",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: `deliverables[${index}].deliverablesConfigItems`,
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "borrowerDocsRows",
        onChange: (selectedItems, formik) => {
          const { deliverables } = formik.values;
          let deliverablesConfigItems = [];

          if (selectedItems !== null && selectedItems.length > 0) {
            deliverablesConfigItems = filterDropDown(selectedItems, deliverables, index);
          }
          deliverables[index].deliverablesConfigItems = deliverablesConfigItems;
          formik.setValues({ ...formik.values, deliverables });
        }
      }
    ]
  },
  listOfDocumentsToBeDelivered: {
    isVisible: data => data.deliverables[index].deliverableType !== "cashManagement" || (data.deliverables[index].deliverableType === "cashManagement" && !data.deliverables[index].reportingEntityId),
    label: "List of documents to be delivered",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: `deliverables[${index}].deliverablesConfigItems`,
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: reportType,
        onChange: (selectedItems, formik) => {
          const { deliverables } = formik.values;
          let deliverablesConfigItems = [];

          if (selectedItems !== null && selectedItems.length > 0) {
            deliverablesConfigItems = filterDropDown(selectedItems, deliverables, index);
          }
          deliverables[index].deliverablesConfigItems = deliverablesConfigItems;
          formik.setValues({ ...formik.values, deliverables });
        }
      }
    ]
  },
  requiredCalculations: {
    label: "Required Calculations",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: `deliverables[${index}].requiredCalculations`,
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "requiredCalculations",
        onChange: (selectedItems, formik) => {
          const { deliverables } = formik.values;
          let requiredCalculations = [];

          if (selectedItems !== null && selectedItems.length > 0) {
            requiredCalculations = filterDropDown(selectedItems, deliverables, index);
          }
          deliverables[index].requiredCalculations = requiredCalculations;
          formik.setValues({ ...formik.values, deliverables });
        }
      }
    ]
  },
});

export default FinancialReportingEditRows;
